import { CatalogService } from './CatalogService';

export class DivisionService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }

    async GetAllFilteredByCompanyAndDivision(searchText?:string, companyId?:string,warehouseId?:string ){
        let divisions = await this.GetAll(searchText);
        
        if(companyId){
            divisions = divisions.filter((warehouse:any)=>warehouse.companyId === companyId)
        }
        if(warehouseId){
            divisions = divisions.filter((warehouse:any)=>warehouse.divisionId === companyId)
        }
        return divisions
    }
}